(() => {
  const icons = {
    gift:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 10h18v4H3zM5 14v7h14v-7M12 10v11M12 10H8a3 3 0 1 1 3-3l1 3Zm0 0h4a3 3 0 1 0-3-3l-1 3Z"/></svg>',
    trash:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 14h10l1-14M10 10v7M14 10v7"/></svg>',
    tag:'<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m2 10 8-8h7v7l-8 8-7-7Z" fill="currentColor"/><circle cx="13.5" cy="5.5" r="1.4" fill="white"/></svg>'
  };
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const clamp = value => Math.max(0, Math.min(99, parseInt(value, 10) || 0));
  class VeluraCart {
    constructor(section) {
      this.section = section;
      this.config = JSON.parse(section.querySelector('[data-vc-config]').textContent);
      this.strings = this.config.strings;
      this.dialog = section.querySelector('.vc-drawer');
      this.cart = JSON.parse(section.querySelector('[data-vc-initial]').textContent);
      this.demo = false;
      this.forceReal = false;
      this.busy = false;
      this.removedGifts = new Set();
      this.dialog.querySelectorAll('[data-vc-gift-icon]').forEach(node => {node.innerHTML = icons.gift;});
      this.dialog.addEventListener('click', event => this.onClick(event));
      this.dialog.addEventListener('change', event => {
        if (event.target.matches('[data-vc-quantity]')) this.change(event.target.dataset.key, clamp(event.target.value));
      });
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        if (this.previousFocus?.isConnected) this.previousFocus.focus();
      });
      this.dialog.querySelector('.vc-checkout-form').addEventListener('submit', event => {
        if (this.demo || this.busy || !this.cart.items.length) event.preventDefault();
      });
      this.render();
    }
    find(selector) { return this.dialog.querySelector(selector); }
    text(key, values = {}) {
      let text = this.strings[key] || '';
      for (const [name,value] of Object.entries(values)) text = text.replaceAll(`{{ ${name} }}`, String(value)).replaceAll(`__${name}__`,String(value));
      return text;
    }
    money(amount) {
      return new Intl.NumberFormat(document.documentElement.lang || 'de', {style:'currency',currency:this.cart.currency || 'EUR'}).format(amount / 100);
    }
    async request(endpoint, body) {
      const options = {credentials:'same-origin',headers:{Accept:'application/json'}};
      if (body !== undefined) {
        options.method = 'POST';
        if (body instanceof FormData) options.body = body;
        else {options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(body);}
      }
      const response = await fetch(`${this.config.root}${endpoint}`, options);
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : this.text('error'));
      return data;
    }
    examples(quantity = 1) {
      const row = (key,title,image,price,original,kind,q = 1) => ({key,product_title:title,image,quantity:q,final_line_price:price*q,original_line_price:original*q,kind});
      const items = [
        row('example-device',this.text('device_title'),this.config.deviceImage,8999,8999,'device',quantity),
        row('example-ebook',this.text('ebook_title'),this.config.ebookImage,0,0,'ebook'),
        row('example-gel',this.text('gel_title'),this.config.gelImage,0,2499,'gel')
      ];
      return {items,currency:'EUR',total_price:8999*quantity,total_discount:2499,examplePriority:false};
    }
    kind(item) {
      if (this.demo) return item.kind;
      if (Number(item.product_id) === Number(this.config.gelId)) return 'gel';
      if (Number(item.product_id) === Number(this.config.ebookId)) return 'ebook';
      if (Number(item.product_id) === Number(this.config.deviceId)) return 'device';
      return 'product';
    }
    isPriority(item) { return !this.demo && this.config.priorityId && Number(item.product_id) === Number(this.config.priorityId); }
    async open(example = false, quantity = 1) {
      if (!this.dialog.open) {
        this.previousFocus = document.activeElement;
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
      }
      if (example && this.config.editor) {
        this.demo = true;
        this.cart = this.examples(quantity);
        this.render();
        return;
      }
      this.find('[data-vc-status]').textContent = this.text('loading');
      try {
        const cart = await this.request('cart.js');
        this.demo = Boolean(this.config.editor && this.config.examples && !this.forceReal && !cart.items.length);
        this.cart = this.demo ? this.examples() : cart;
        this.render();
      } catch (error) {
        this.find('[data-vc-status]').textContent = this.text('error');
      }
    }
    tag(text) {
      const node = element('span','vc-tag');
      node.innerHTML = icons.tag;
      node.append(document.createTextNode(text));
      return node;
    }
    row(item) {
      const kind = this.kind(item);
      const row = element('article','vc-item');
      row.dataset.kind = kind;
      const image = element('img');
      image.width = 80; image.height = 90; image.decoding = 'async'; image.loading = 'lazy';
      image.src = kind === 'gel' ? this.config.gelImage : kind === 'ebook' ? this.config.ebookImage : item.image || this.config.deviceImage;
      image.alt = kind === 'gel' ? this.text('gel_title') : item.product_title;
      const content = element('div','vc-item-content');
      const title = element('h3');
      if (kind === 'ebook') {
        const words = this.text('ebook_title').split(' ');
        title.append(document.createTextNode(words.slice(0,2).join(' ')),document.createElement('br'),document.createTextNode(words.slice(2).join(' ')));
      }
      else title.textContent = kind === 'gel' ? this.text('gel_title') : item.product_title;
      content.append(title);
      if (kind === 'gel') content.append(element('p','vc-size',this.text('size')));
      else if (item.variant_title && item.variant_title !== 'Default Title') content.append(element('p','vc-variant',item.variant_title));
      const price = element('p', item.original_line_price > item.final_line_price ? 'vc-price-sale' : 'vc-item-price');
      if (item.original_line_price > item.final_line_price) {
        price.append(element('s','',this.money(item.original_line_price)),document.createTextNode(' '),element('span','vc-final',this.money(item.final_line_price)),document.createTextNode(' '),element('strong','',`(${this.text('save',{amount:this.money(item.original_line_price-item.final_line_price)})})`));
      } else price.textContent = this.money(item.final_line_price);
      content.append(price);
      const controls = element('div','vc-quantity-tag');
      const quantity = element('div','vc-quantity');
      for (const direction of [-1,1]) {
        const button = element('button','',direction === -1 ? '−' : '+');
        button.type = 'button'; button.dataset.vcStep = direction; button.dataset.key = item.key;
        button.setAttribute('aria-label',this.text(direction === -1 ? 'minus' : 'plus'));
        if (direction === 1) {
          const input = element('input');
          input.type = 'number'; input.min = '0'; input.max = '99'; input.value = item.quantity; input.inputMode = 'numeric';
          input.dataset.vcQuantity = ''; input.dataset.key = item.key;
          input.setAttribute('aria-label',`${this.text('quantity')}: ${item.product_title}`);
          quantity.append(input);
        }
        quantity.append(button);
      }
      controls.append(quantity);
      if (kind === 'gel' && item.original_line_price > item.final_line_price) controls.append(this.tag(this.text('device_only')));
      content.append(controls);
      const remove = element('button','vc-remove');
      remove.type = 'button'; remove.dataset.vcRemove = ''; remove.dataset.key = item.key;
      remove.setAttribute('aria-label',`${this.text('remove')}: ${title.textContent}`); remove.innerHTML = icons.trash;
      row.append(image,content,remove);
      return row;
    }
    render() {
      const items = this.cart.items.filter(item => !this.isPriority(item));
      const count = items.reduce((sum,item) => sum+item.quantity,0);
      this.find('[data-vc-count]').textContent = count;
      document.querySelectorAll('[data-velura-cart-count]').forEach(node => {node.textContent = count; node.hidden = !count;});
      this.find('[data-vc-preview]').hidden = !this.demo;
      const editorTools = this.find('[data-vc-editor-tools]');
      if (editorTools) editorTools.hidden = this.demo;
      this.find('[data-vc-items]').replaceChildren(...items.map(item => this.row(item)));
      this.find('[data-vc-empty]').hidden = Boolean(items.length);
      this.find('[data-vc-footer]').hidden = !items.length;
      this.find('[data-vc-status]').textContent = '';
      const rewards = Boolean(items.length && this.config.rewards && (this.demo || this.config.ebookId || this.config.gelId));
      this.find('[data-vc-rewards]').hidden = !rewards;
      if (rewards) {
        const first = Math.max(1,this.config.firstThreshold);
        const second = Math.max(first+1,this.config.secondThreshold);
        const target = count < first ? first : second;
        this.find('[data-vc-reward-message]').textContent = count >= second ? this.text('rewards_unlocked',{gifts:4}) : this.text('rewards_remaining',{count:target-count,gifts:count<first?2:4});
        this.find('[data-vc-progress]').style.width = `${this.demo ? 0 : Math.min(100,count/second*100)}%`;
      }
      const priority = this.demo ? this.cart.examplePriority : this.cart.items.some(item => this.isPriority(item));
      const available = Boolean(this.demo || this.config.priorityAvailable);
      const switchButton = this.find('[data-vc-priority]');
      switchButton.setAttribute('aria-checked',String(priority));
      switchButton.disabled = this.busy || !available;
      this.find('[data-vc-priority-price]').textContent = this.money(this.config.priorityPrice);
      this.find('[data-vc-priority-missing]').hidden = available;
      const discount = this.cart.total_discount || 0;
      this.find('[data-vc-discounts]').hidden = !discount;
      const discountTag = this.find('[data-vc-discount-tag]');
      const discountTitle = this.demo ? this.text('device_only') : (this.cart.cart_level_discount_applications?.[0]?.title || items.flatMap(item=>item.discounts || []).find(item=>item.title)?.title || '');
      discountTag.hidden = !discountTitle;
      discountTag.replaceChildren();
      if (discountTitle) {discountTag.innerHTML = icons.tag; discountTag.append(document.createTextNode(discountTitle));}
      this.find('[data-vc-discount-amount]').textContent = `− ${this.money(discount)}`;
      this.find('[data-vc-total]').textContent = this.money(this.cart.total_price);
      this.find('[data-vc-checkout]').disabled = this.demo || this.busy || !items.length;
    }
    onClick(event) {
      if (event.target === this.dialog) {
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }
      const button = event.target.closest('button');
      if (!button) return;
      if (button.matches('[data-vc-close]')) this.dialog.close();
      if (button.matches('[data-vc-real]')) {this.forceReal = true; this.open();}
      if (button.matches('[data-vc-example]') && this.config.editor) this.open(true);
      if (button.matches('[data-vc-step]')) {
        const item = this.cart.items.find(item => item.key === button.dataset.key);
        if (item) this.change(item.key,clamp(item.quantity+Number(button.dataset.vcStep)));
      }
      if (button.matches('[data-vc-remove]')) this.change(button.dataset.key,0);
      if (button.matches('[data-vc-priority]')) this.priority();
    }
    recalculateExample() {
      this.cart.total_price = this.cart.items.reduce((sum,item)=>sum+item.final_line_price,0)+(this.cart.examplePriority?this.config.priorityPrice:0);
      this.cart.total_discount = this.cart.items.reduce((sum,item)=>sum+item.original_line_price-item.final_line_price,0);
      this.render();
    }
    setBusy(value) {
      this.busy = value;
      this.dialog.setAttribute('aria-busy',String(value));
      this.find('[data-vc-checkout]').disabled = value || this.demo || !this.cart.items.length;
    }
    async normalizeGifts(cart) {
      const deviceQuantity = cart.items.filter(item=>Number(item.product_id)===Number(this.config.deviceId)).reduce((sum,item)=>sum+item.quantity,0);
      const updates = {};
      for (const item of cart.items) {
        if (item.properties?._velura_gift === 'true' && !this.removedGifts.has(item.variant_id) && item.final_line_price === 0 && item.quantity !== deviceQuantity) updates[item.key] = deviceQuantity;
        if (!deviceQuantity && item.properties?._velura_gift === 'true') updates[item.key] = 0;
      }
      const otherItems = cart.items.filter(item=>!this.isPriority(item) && item.properties?._velura_gift !== 'true');
      if (!otherItems.length) cart.items.filter(item=>this.isPriority(item)).forEach(item=>{updates[item.key]=0;});
      return Object.keys(updates).length ? this.request('cart/update.js',{updates}) : cart;
    }
    async change(key, quantity) {
      if (this.busy) return;
      const item = this.cart.items.find(item=>item.key===key);
      if (!item) return;
      if (this.demo) {
        if (!quantity) this.cart.items = this.cart.items.filter(item=>item.key!==key);
        else {
          const previous = item.quantity;
          item.final_line_price = Math.round(item.final_line_price/previous)*quantity;
          item.original_line_price = Math.round(item.original_line_price/previous)*quantity;
          item.quantity = quantity;
        }
        if (!this.cart.items.length) this.cart.examplePriority = false;
        this.recalculateExample();
        return;
      }
      if (!quantity && item.properties?._velura_gift === 'true') this.removedGifts.add(item.variant_id);
      this.setBusy(true);
      try {
        this.cart = await this.normalizeGifts(await this.request('cart/change.js',{id:key,quantity}));
        this.render();
        this.find('[data-vc-status]').textContent = this.text('updated');
      } catch (error) {
        try {this.cart = await this.request('cart.js'); this.render();} catch {}
        this.find('[data-vc-status]').textContent = error.message || this.text('error');
      } finally {this.setBusy(false); this.find('[data-vc-priority]').disabled = !this.config.priorityAvailable;}
    }
    async priority() {
      if (this.busy) return;
      if (this.demo) {this.cart.examplePriority = !this.cart.examplePriority; this.recalculateExample(); return;}
      if (!this.config.priorityAvailable) return;
      this.setBusy(true);
      try {
        const item = this.cart.items.find(item=>this.isPriority(item));
        if (item) this.cart = await this.request('cart/change.js',{id:item.key,quantity:0});
        else {
          await this.request('cart/add.js',{items:[{id:this.config.priorityVariant,quantity:1,properties:{_velura_priority:'true'}}]});
          this.cart = await this.request('cart.js');
        }
        this.render();
      } catch (error) {this.find('[data-vc-status]').textContent = error.message || this.text('error');}
      finally {this.setBusy(false); this.find('[data-vc-priority]').disabled = !this.config.priorityAvailable;}
    }
    async add(form, submitter) {
      const data = new FormData(form);
      const quantity = Math.max(1,clamp(data.get('quantity') || 1));
      const unavailable = form.dataset.veluraUnavailable === 'true' || form.querySelector('[data-velura-product-availability="false"]');
      if (this.config.editor && unavailable) {await this.open(true,quantity); return;}
      if (unavailable || this.busy) return;
      this.busy = true;
      if (submitter) {submitter.disabled = true; submitter.setAttribute('aria-busy','true');}
      let status = form.querySelector('[data-vc-form-status]');
      if (!status) {status = element('p','vc-status'); status.dataset.vcFormStatus = ''; status.setAttribute('role','status'); form.append(status);}
      status.textContent = '';
      try {
        const gifts = this.config.autoGifts ? [this.config.ebookVariant,this.config.gelVariant].filter(Boolean) : [];
        if (gifts.length) {
          const items = [{id:Number(data.get('id')),quantity},...gifts.map(id=>({id,quantity,properties:{_velura_gift:'true'}}))];
          await this.request('cart/add.js',{items});
        } else await this.request('cart/add.js',data);
        this.forceReal = true;
        await this.open();
      } catch (error) {status.textContent = error.message || this.text('error');}
      finally {this.busy = false; if (submitter) {submitter.disabled = false; submitter.removeAttribute('aria-busy');} if (this.dialog.open) this.render();}
    }
  }
  let controller;
  const init = () => {
    const section = document.querySelector('[data-velura-cart-section]');
    if (!section || section.dataset.initialized) return;
    const previousOpen = controller?.dialog.open;
    if (previousOpen) controller.dialog.close();
    section.dataset.initialized = 'true';
    controller = new VeluraCart(section);
    if (previousOpen || controller.config.autoOpen) controller.open();
  };
  document.addEventListener('click',event=>{
    if (!controller || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = event.target.closest('a[href], [data-velura-cart-open]');
    if (!target) return;
    const cartPath = `${controller.config.root}cart`.replace(/\/$/,'');
    const isCart = target.hasAttribute('data-velura-cart-open') || new URL(target.href,location.href).pathname.replace(/\/$/,'') === cartPath;
    if (isCart) {event.preventDefault(); controller.open();}
  });
  document.addEventListener('submit',event=>{
    if (!controller || !event.target.matches('#VeluraProductForm, .home-product-form')) return;
    event.preventDefault();
    controller.add(event.target,event.submitter);
  });
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:select',event=>{
    if (controller && event.target.contains(controller.section)) controller.open();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
